import { useContext } from "react";
import InputStateContext from "./index";

const useInputState = () => useContext(InputStateContext)!;

export default useInputState;
